'use client';
import { Columns as SharedColumns } from '@launchstore/shared-puck';
import type { ColumnsProps } from '@launchstore/shared-puck';
export const Columns: any = SharedColumns;
export type { ColumnsProps };
export default Columns;
